import { render, staticRenderFns } from "./NumberMetric.vue?vue&type=template&id=9ffab730&scoped=true"
import script from "./NumberMetric.vue?vue&type=script&lang=js"
export * from "./NumberMetric.vue?vue&type=script&lang=js"
import style0 from "./NumberMetric.vue?vue&type=style&index=0&id=9ffab730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffab730",
  null
  
)

export default component.exports